import React, { useState } from "react";
import axios from "axios";
import "../styles/Forecast.css";

import ForecastDay from "./ForecastDay";

export default function Forecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);

  function getResponse(response) {
    setLoaded(true);
    setForecast(response.data.daily);
  }

  if (loaded) {
    return (
      <div className="Forecast">
        <div className="section">
          {forecast.map(function (dailyForecast, index) {
            if (index > 0) {
              return <ForecastDay data={dailyForecast} key={index} />;
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  } else {
    let API_KEY = "e34d0t2732c4955489449b41af8fo3a4";
    let url = `https://api.shecodes.io/weather/v1/forecast?lon=${props.data.lon}&lat=${props.data.lat}&key=${API_KEY}&units=metric`;
    axios.get(url).then(getResponse);

    return null;
  }
}
